import { PaginationDropdownLimit, DefaultPaginationDropdownLimits } from '@mesa-labs/mesa-ui/dist/components/Pagination';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { types as api } from '@mesa-labs/mesa-api';

import { TaskService } from '../../types';

const DefaultPaginationDropdownLimit = DefaultPaginationDropdownLimits[0];

export type ServiceAgreementsState = {
  type?: api.ServiceAgreementType;
};

export const initialState: ServiceAgreementsState = {
  type: api.ServiceAgreementType.Standard,
};

const serviceAgreementsSlice = createSlice({
  name: 'serviceAgreements',
  initialState,
  reducers: {
    updateType(state: ServiceAgreementsState, action: PayloadAction<api.ServiceAgreementType>) {
      state.type = action.payload;
    },
  },
});

export const {
  updateType,
} = serviceAgreementsSlice.actions;
export default serviceAgreementsSlice.reducer;
